import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        title: '登录'
    },
    {
        path: '/forget-password',
        name: 'forget-password',
        component: () => import('@/views/forget-password/index.vue'),
        title: '忘记密码'
    },
    {
        path: '/activation',
        name: 'activation',
        component: () => import('@/views/activation/index.vue'),
        title: '新钥匙激活'
    },
    {
        path: '/maintain-data-modify',
        name: 'maintain-data-modify',
        component: () => import('@/views/maintain-data-modify/index.vue'),
        title: '维护-个人资料修改'
    },
    {
        path: '/maintain-password-modify',
        name: 'maintain-password-modify',
        component: () => import('@/views/maintain-password-modify/index.vue'),
        title: '维护-修改密码'
    },
    {
        path: '/maintain-history-report',
        name: 'maintain-history-report',
        component: () => import('@/views/maintain-history-report/index.vue'),
        title: '维护-历史报表查询'
    },
    {
        path: '/base-info',
        name: 'base-info',
        component: () => import('@/views/base-info/index.vue'),
        title: '录入-基本信息'
    },
    {
        path: '/select-age',
        name: 'select-age',
        component: () => import('@/views/select-age/index.vue'),
        title: '录入-选择年龄'
    },
    {
        path: '/input-adult-self-evaluation',
        name: 'input-adult-self-evaluation',
        component: () => import('@/views/input-adult-self-evaluation/index.vue'),
        title: '录入-成人版-自评'
    },
    {
        path: '/input-adult-his-comments',
        name: 'input-adult-his-comments',
        component: () => import('@/views/input-adult-his-comments/index.vue'),
        title: '录入-成人版-他评'
    },
    {
        path: '/children-parents',
        name: 'children-parents',
        component: () => import('@/views/children-parents/index.vue'),
        title: '录入-家长评-儿童版'
    },
    {
        path: '/children-teachers',
        name: 'children-teachers',
        component: () => import('@/views/children-teachers/index.vue'),
        title: '录入-教师评-儿童版'
    },
    {
        path: '/infant-parents',
        name: 'infant-parents',
        component: () => import('@/views/infant-parents/index.vue'),
        title: '录入-家长评-幼儿版'
    },
    {
        path: '/infant-teachers',
        name: 'infant-teachers',
        component: () => import('@/views/infant-teachers/index.vue'),
        title: '录入-教师评-幼儿版'
    },
    {
        path: '/',
        redirect: '/index',
        title: '录入-教师评-幼儿版'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index.vue'),
        title: '录入-教师评-幼儿版'
    },

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
